<script setup>
import MenuDropdown from '../../../../_02_molecules/components/MenuDropdown.vue';
import DownloadInvoiceAction from '../actions/DownloadInvoiceAction.vue';

const props = defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});

</script>

<template>
  <MenuDropdown v-if="invoice">
    <template #start>
      <ul>
        <DownloadInvoiceAction v-if="invoice.invoice_url" :invoice-url="invoice.invoice_url" class="dropdown-ubiq--separator" />
      </ul>
    </template>
  </MenuDropdown>
</template>
